/* INPUT: "2022-04-13" | OUTPUT: '13.04.2022' */

export const dateReversePoint = (date = '') => {
  return date.split('-').reverse().join('.');
};
